
// Vue
import { Component, Vue, Watch, Prop } from "vue-property-decorator";
import { namespace } from "vuex-class";

// Components
import VuePerfectScrollbar from "vue-perfect-scrollbar";

// Services
import api from "../../services/api.service";

// Types
import { Region } from "@/store/types";
import { Response } from "@/store/responses/types";
import { AlarmPointHistory } from "@/types/AlarmPoints";


// Vuex namespaces
const AlarmPoints = namespace("alarmPoints");

@Component({
	components: {
		VuePerfectScrollbar
	}
})
export default class ImmixHistory extends Vue {
	$refs!: {
		accessHistory: any;
	};

	@AlarmPoints.Getter("getSelectedResponse") response: Response;

	@Prop({ default: null }) public region: Region | null;

	private fetchingHistory: boolean = false;

	public historyItems: AlarmPointHistory[] = [];

	private filter: string = "";

	private async mounted(): Promise<void> {
		await this.getResponseHistory(this.response);
	}

	public get filteredHistory(): any[] {
		if (this.filter == "") return this.historyItems;

		var filterLower = this.filter.toLowerCase();

		return this.historyItems.filter(
			historyItem =>
				historyItem.details &&
				historyItem.details.toLowerCase().indexOf(filterLower) > -1
		);
	}

	@Watch("response", { deep: true })
	private async onResponseChanged(value: Response, oldValue: Response): Promise<void> {
		if (!value) {
			this.historyItems = [];
			return;
		}

		await this.getResponseHistory(value);
	}

	private async getResponseHistory(response: Response): Promise<void> {
		if (!response) return;

		this.fetchingHistory = true;

		const res = await api.responseHistory(response.responseID, this.region?.url ?? "");

		this.historyItems = res ? res : [];

		this.fetchingHistory = false;
	}
}
